import React, { useMemo, useState, useEffect } from "react";
import "../../../pages/adminSetting/StickerManagement/style.scss";
import {useImageLoader} from "../../customHook/ImageLoader";

export default function StickerItem({
                                           resourceId,
                                           frameCount = 1,
                                           size = 75,
                                           autoPlayOnMount = false,
                                           duration = frameCount > 5 ? 1000 : 500,
                                           playDuration = 5000,
                                       }) {
    const { imageUrl } = useImageLoader(resourceId);
    const [isPlaying, setIsPlaying] = useState(autoPlayOnMount);
    const totalWidth = frameCount * size;

    const animationName = useMemo(
        () => `playSticker_${frameCount}_${size}_${Math.random().toString(36).substring(2, 8)}`,
        [frameCount, size]
    );

    useEffect(() => {
        const styleSheet = document.styleSheets[0];
        const keyframes = `
      @keyframes ${animationName} {
        from { background-position: 0 0; }
        to { background-position: -${totalWidth}px 0; }
      }
    `;
        styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
        return () => {
            const index = Array.from(styleSheet.cssRules).findIndex(
                (r) => r.name === animationName
            );
            if (index > -1) styleSheet.deleteRule(index);
        };
    }, [animationName, totalWidth]);

    useEffect(() => {
        if (!isPlaying) return;
        const stopTimer = setTimeout(() => setIsPlaying(false), playDuration);
        return () => clearTimeout(stopTimer);
    }, [isPlaying, playDuration]);

    const stickerStyle = {
        width: `${size}px`,
        height: `${size}px`,
        backgroundImage: `url(${imageUrl})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0 0",
        backgroundSize: `${totalWidth}px ${size}px`,
        animation: isPlaying
            ? `${animationName} ${duration}ms steps(${frameCount}) infinite`
            : "none",
        cursor: "pointer",
    };

    return (
        <div
            className="sticker"
            style={stickerStyle}
            onMouseEnter={() => setIsPlaying(true)}
        />
    );
}
